import { render, staticRenderFns } from "./UnassignedCommitmentList.vue?vue&type=template&id=5906f076&"
import script from "./UnassignedCommitmentList.vue?vue&type=script&lang=js&"
export * from "./UnassignedCommitmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports